"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNucleiFormatting = void 0;
function mapNucleiFormatting(formatting) {
    const { nuclei, ...res } = formatting;
    return {
        nuclei: Object.fromEntries(Object.keys(nuclei).map((key) => [
            nuclei[key].name.trim().toLowerCase(),
            nuclei[key],
        ])),
        ...res,
    };
}
exports.mapNucleiFormatting = mapNucleiFormatting;
